import { NavLink } from "react-router-dom";
import { useAuthStore } from "@/state/auth.store";
import { useLang } from "@/i18n/LanguageContext";

/** Secondary nav for tenant tools — shown to managers and org-admins only. */
export function TenantNav() {
  const role = useAuthStore((s) => s.user?.role);
  const { t } = useLang();
  if (role !== "org_admin" && role !== "manager") return null;
  return (
    <nav className="app-subnav">
      <NavLink to="/app" end>Dashboard</NavLink>
      <NavLink to="/app/content">Content</NavLink>
      <NavLink to="/app/segments">{t("Doelgroepen", "Audiences")}</NavLink>
      <NavLink to="/app/journeys">{t("Trajecten", "Journeys")}</NavLink>
      <NavLink to="/app/reports">{t("Voortgang", "Progress")}</NavLink>
      {role === "org_admin" && <NavLink to="/app/audit">Audit</NavLink>}
      {role === "org_admin" && <NavLink to="/app/branding">{t("Huisstijl", "Branding")}</NavLink>}
    </nav>
  );
}
